import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  constructor() {}

  /**
   * Funtion used on dymamic viewes
   * 
   * Evaluates if a field should be displayed based on its display controls
   * @param field The field configuration
   * @param record for display controls
   * @returns boolean indicating if the field should be displayed
   */
  shouldDisplayField(field: any, record: any): boolean {
    // If field has displayControls and displayType, check them
    if (field.displayControls && field.displayType) {
      // Get the value that controls this field's visibility
      const controlValue = record[field.displayType];
      
      // Check each display control
      for (const [key, control] of Object.entries(field.displayControls)) {
        if (typeof control === 'function') {
          // If any control returns false, hide the field
          if (!control(controlValue, key)) {
            return false;
          }
        }
      }
    }
    
    // If no display controls or all controls pass, show the field
    return true;
  }

  async wait(time: number) {
    return new Promise(resolve => setTimeout(resolve, time));
  }
}
